import type { Point, Rect } from './types';

export interface PhotoSize {
  readonly width: number;
  readonly height: number;
}

/**
 * 사진 % 좌표(0~100)를 사진 px 로 바꾼다. 가로는 사진 폭, 세로는 사진 높이 기준이다.
 * 원통 식은 축별 선형이라 % 공간에서 계산한 뒤 바꿔도 결과가 같다.
 * 다만 위·아래 곡률 같은 세로 길이를 % 로 둘 때는 사진 높이로 바꿔야 한다. 폭으로 바꾸면 정사각형이 아닌 사진에서 타원이 찌그러진다.
 */
export function photoPercentToPx(point: Point, photo: PhotoSize): Point {
  return { x: (point.x * photo.width) / 100, y: (point.y * photo.height) / 100 };
}

/** 사진 px 를 사진 % 좌표(0~100)로 바꾼다. */
export function photoPxToPercent(point: Point, photo: PhotoSize): Point {
  return { x: (point.x * 100) / photo.width, y: (point.y * 100) / photo.height };
}

/** 사진 % 사각형을 사진 px 사각형으로 바꾼다. */
export function photoPercentRectToPx(rect: Rect, photo: PhotoSize): Rect {
  const topLeft = photoPercentToPx({ x: rect.left, y: rect.top }, photo);
  const size = photoPercentToPx({ x: rect.width, y: rect.height }, photo);
  return { left: topLeft.x, top: topLeft.y, width: size.x, height: size.y };
}
